/**
 * 使用範例 
 * v-integer
 * <input type="text" v-integer value="60" v-model="item.coaCnt">
 */
const NumericDirective = {
  bind(el) {
    el.addEventListener('keyup', () => {
      let regex = /^[0-9]*$/
      if (!regex.test(el.value)) {
        el.value = el.value.slice(0, -1)
      }
      })
  }
}
export default NumericDirective